module.exports = __webpack_public_path__ + "img/tounyu_amazake.3ddb34f7.jpg";